import React from 'react'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { projectFormPreviewSelector } from 'src/features'
import { CustomModal, ProjectDetails } from 'src/components'

interface PropsType {
  isModalVisible: boolean
  handleClose: () => void
}

const ProjectPreviewModal: React.FC<PropsType> = ({ isModalVisible, handleClose }) => {
  const { t } = useTranslation()
  const projectPreview = useAppSelector(projectFormPreviewSelector)

  const handleCancel = () => {
    handleClose()
  }

  return (
    <CustomModal
      title={t('Projects.ProjectPreview')}
      footer={null}
      open={isModalVisible}
      onCancel={handleCancel}
      centered
      width={1000}
    >
      <ProjectDetails
        project={projectPreview}
        isModalPreview={true}
      />
    </CustomModal>
  )
}

export default ProjectPreviewModal
